var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    {
      staticClass: "secondarybackground",
      staticStyle: { "overflow-y": "auto" },
      attrs: { height: "180" }
    },
    [
      _c(
        "v-card-text",
        { staticClass: "caption" },
        [
          _c(
            "div",
            {
              staticClass: "font-weight-bold subtitle-2 ml-5 mb-2 font-italic"
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.item.technical_inventory_code) +
                  " -\n      " +
                  _vm._s(_vm.item.technical_inventory_name) +
                  "\n    "
              )
            ]
          ),
          _vm._v(" "),
          _vm._l(_vm.item.children, function(line) {
            return _c("div", { key: line.technical_inventory_code }, [
              _vm._v(
                "\n      " +
                  _vm._s(line.technical_inventory_code) +
                  " -\n      " +
                  _vm._s(line.technical_inventory_name) +
                  " (" +
                  _vm._s(line.etat) +
                  ")\n      "
              ),
              _c("span", { staticClass: "font-italic" }, [
                _vm._v(_vm._s(line.comment))
              ])
            ])
          })
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }